import { useEffect } from "react";

export function usePreventSwipeNavigation(enabled: boolean = true) {
  useEffect(() => {
    if (!enabled) return;

    const handleTouchMove = (event: TouchEvent) => {
      if (event.touches.length === 1) {
        const touchX = event.touches[0].clientX;
        const screenWidth = window.innerWidth;

        if (touchX < 50 || touchX > screenWidth - 50) {
          event.preventDefault();
        }
      }
    };

    document.addEventListener("touchmove", handleTouchMove, { passive: false });

    return () => {
      document.removeEventListener("touchmove", handleTouchMove);
    };
  }, [enabled]);
}
